/**
 * cấp cơ quan thu
 */
export default {
    Center: 1,
    /*
     * tỉnh
     */
    Province: 2,
    /*
     * Huyện
     */
    District: 3,
    /*
     * xã
     */
    Wards: 4
  };
  